let localStorageEnabledCached = null
export const isLocalStorageEnabled = () => {
  if (localStorageEnabledCached !== null) {
    return localStorageEnabledCached
  }
  try {
    window.localStorage.setItem("slideshare_test", "test")
    window.localStorage.removeItem("slideshare_test")
    localStorageEnabledCached = true
    return localStorageEnabledCached
  } catch (e) {
    localStorageEnabledCached = false
    return localStorageEnabledCached
  }
}

export const loadFromStorage = (name) => {
  if (!isLocalStorageEnabled()) {
    return null
  }
  return JSON.parse(window.localStorage.getItem(name) || "{}")
}

export const saveToStorage = (name, value) => {
  if (!isLocalStorageEnabled()) {
    return null
  }
  window.localStorage.setItem(name, JSON.stringify(value))
}
